import { createSelector } from 'reselect'

export const getState = state => state.locations

export const isLoading = createSelector(getState, state => state.isLoading)

export const getLocationsError = createSelector(getState, state => state.error)

export const getLocations = createSelector(getState, state => state.locations)
